module.exports = "https://static.wanderu.com/static/media/cnn-money.55c1ebb9.png";